import React, {Component, cloneElement} from 'react';

import {FmlxButton, FmlxIcon} from 'fmlx-common-ui';
import PropTypes from 'prop-types';

import productLogo from '@/assets/svg/formulatrix-logo.svg';
import {gapFixerClass} from '@/libs/styleHelper';

import withIntl from '../../libs/withIntl';
import IntlMessage from '../intlMessage/IntlMessage';

import './ErrorBoundary.scss';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidMount() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const forceError = urlSearchParams.get('error') === 'true';

    if (forceError) {
      const err = new Error('Error triggered');
      setTimeout(() => {
        this.setState({
          hasError: true,
          error: null,
          info: null,
        });
      }, 6000);
      // You can also log the error to an error reporting service.
      console.error('ErrorBoundary error', err);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {errorBoundary} = this.props;
    const {error: errorState, info: infoState} = this.state;
    const {error, info, hasError, isHandled} = errorBoundary;

    if (prevState.hasError !== hasError && hasError !== prevProps.errorBoundary.hasError && hasError && !isHandled) {
      this.setError(error, info);
      console.log('Unhandled ErrorBoundary error', error);
      console.log('Unhandled ErrorBoundary info', info);
    }

    if (prevState.error !== errorState && prevState.info !== infoState) {
      this.setError(error, info);
      console.log('Unhandled ErrorBoundary error', error);
      console.log('Unhandled ErrorBoundary info', info);
    }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, info) {
    const {setErrorBoundary} = this.props;

    console.error('ErrorBoundary error', error);
    console.error('ErrorBoundary info', info);
    // Display UI Fallback.
    this.setError(error, info);
    // You can also log the error to an error reporting service.
    setErrorBoundary(true, error, info, null, true);
  }

  setError = (error, info) => {
    const {sendError} = this.props;
    console.error('setError', error, info);
    this.setState({
      hasError: true,
      error,
      info,
    });
    sendError(error, info);
  };

  render() {
    const {hasError, error, info} = this.state;
    const {children, intl, onClick, content} = this.props;

    if (hasError) {
      if (content) {
        const _content = cloneElement(content, {error, info});
        return _content;
      }
      return (
        <div className="com-error-boundary">
          <div className="logo">
            <img
              src={productLogo}
              alt="Formulatrix"
              style={{display: 'inline-block', margin: '0 10px 0 5px'}}
            />
          </div>
          <br />
          <br />
          <div className="message-content">
            <IntlMessage id="main.errorBoundary.message" />
          </div>
          <br />
          <br />
          <div className="details">
            <div className={`stack-buttons ${gapFixerClass()}`}>
              <FmlxButton
                type={FmlxButton.Type.BASIC}
                variant={FmlxButton.Variant.OUTLINE}
                icon={<FmlxIcon name="Refresh" />}
                onClick={onClick}
                label={intl.formatMessage({id: 'main.errorBoundary.primaryButton'})}
              />
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  errorBoundary: PropTypes.shape({
    error: PropTypes.any,
    hasError: PropTypes.bool,
    info: PropTypes.any,
    isHandled: PropTypes.bool,
  }),
  intl: PropTypes.any,
  sendError: PropTypes.func,
  setErrorBoundary: PropTypes.func,
  onClick: PropTypes.func,
  content: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  children: null,
  content: null,
  errorBoundary: {},
  intl: {},
  sendError: () => {},
  setErrorBoundary: () => {},
  onClick: () => {},
};

export default withIntl(ErrorBoundary);
